// const LOS_SERVICE_CONTEXT = "loan-service";
const LOS_SERVICE_CONTEXT = "los";
const CORE_SERVICE_CONTEXT = "core";
const LMS_SERVICE_CONTEXT = "lms";
const AUTH_SERVICE_CONTEXT = "auth";

/* eslint-disable prettier/prettier */
export const endpoint = {
    BASE_URL_STAGING: window.location.host === "localhost:3000" ? "http://localhost:4004": window.location.origin,
    FEATURE_FLAG: "/app/feature-flag",
    RETAIN_TOKEN: "auth/v1/oauth2/user/retain-token/",
    USER_DETAIL: "core/v1/admin/user/detail",
    LOGO_URL :"core/v1/link/logo-url",
    UI_RESTRICTION_FIND:"core/v1/ui/restriction/find?",
    APP_URL: "/app/url-link",
    // Authentication / Authorization
    MOBILE_STATUS_API:'core/v1/user/exists?username=',
    CHECK_USER_DETAILS:'core/v1/user/exists?username=',
    USER_SIGN_UP_API:'core/v1/user/signup',
    USER_LOGIN_API:'core/v1/user/login-with-otp',
    USER_LOGOUT_API:'auth/v1/oauth/user/logout',
    VALIDATE_OTP_API:'core/v1/user/verify-login-otp',
    RESEND_OTP_API:'auth/v1/oauth/user/sendOtp',
    USER_UPDATE_PAN_CARD_API:'pls/v1/pan-kyc/update',
    FIND_USER_LOAN_DETAILS_API:'pls/v1/lead/search?mobileNumber=',
    USER_LOAN_REPAYMENT_DETAILS_API:'lms/v1/loan/detail/find?loanAccountNumber=',
    GET_ALL_LEAD_DETAILS:"pls/v1/lead/details/find/",
    GET_LEAD_INCOME_DETAILS_API:"pls/ploan/income-detail/findByLead/",
    GET_USER_PAN_DETAILS_API:"core/v1/prospect/get/",
    GET_USER_PPF_DETAILS_API:"pls/v1/epf/find/",
    NEW_LEAD_CREATE_API:"pls/v1/lead/create",
    ALREADY_LEAD_PRESENT_API:"pls/ploan/income-detail/create",
    GET_GENERAL_INFORMATION_API:"pls/v1/applicant/detail/find/",
    FIND_RELATIONSHIP_TYPE_API:"core/v1/relationship-master/findAll",
    GET_LEAD_REFERENCE_DETAILS_API:"pls/v1/lead/referal/find/",
    CREATE_LEAD_REFERENCE_DETAILS_API:"pls/v1/lead/referal/add-update-bulk/",
    AADHAR_KYC_INITIATE_API:"pls/v1/adhaar-kyc/init",
    FILE_UPLOAD: "core/v1/file/upload",
    GET_USER_LOAN_AMOUNT_DETAILS_API: "pls/v1/lead/calculate/loan-amount/",
    GET_LOAN_SCHEME_DETAILS_API: "core/v1/loan/scheme/find/eligible/Personal Loan?loanAmount=",
    GET_LOAN_PAYMENT_DETAILS_API:`pls/v1/loan/lead/interest/calculateAndUpdate/`,
    GET_LOAN_REPAYMENT_DETAILS_API:'pls/v1/lead/repayment/calculateAndUpdate/',
    IFSC_CODE_VERIFIED_API:'pls/v1/applicant/ifsc/find/',
    GENERATE_SANCTION_LETTER:'pls/v1/lead-application/document/generate/sanction-letter/',
    USER_SANCTION_LETTER_ESTAAP_API:'pls/v1/lead-application/estamp/sanction-letter/',
    GET_LEAD_ALL_DOCUMENTS_API:"pls/v1/lead-application/document/find/",
    USER_SANCTION_LETTER_ESIGN_API:"pls/v1/lead-application/esign/sanction-letter/",
    USER_LEAD_LOAN_AMOUNT_API:"pls/v1/lead/calculate/loan-amount/",
    USER_LEAD_DETAILS_FIND_API:"pls/v1/lead/find/",
    USER_LEAD_DETAILS_UPDATE_API:"pls/v1/lead/update/",
    USER_FIND_MANDATE_DETAILS_API:"pls/v1/lead/mandate/find/",
    USER_CREATE_MANDATE_DETAILS_API:"pls/v1/lead/mandate/create",
    AADHAR_KYC_DETAILS_API:"pls/v1/adhaar-kyc/details",
    USER_PROFILE_SCREEN_FLAGS_API:"pls/v1/lead/info/profile-info/",
    USER_UPLOAD_PAN_CARD_API:"pls/v1/pan-kyc/upload-pan",
    USER_UPLOAD_SELFIE_API:"pls/v1/applicant/photo/upload-selfe",
    USER_CREATE_GENERAL_DETAILS_API:"pls/v1/applicant/detail/create",
    USER_CREATE_APPLICANT_ADDRESS_API:"pls/v1/applicant-address/create",
    USER_GET_APPLICANT_ADDRESS_API:"pls/v1/applicant-address/find/",
    USER_CREATE_LOAN_NUMBER_CUSTOMER_ID_API:"pls/v1/applicant/profile/createProfileAndGenerateLoanAccountNumber",
    USER_DATA_MOBILE_NUMBER_API:"pls/v1/customer/profile/",
    USER_BANK_VALIDATE_API:"core/v1/pennydrop/verify/bank-account",
    USER_BANK_DETAILS_CREATE_API:"pls/v1/applicant/bank/create/",
    USER_BANK_DETAILS_FIND_API:"pls/v1/applicant/bank/find/",
    USER_DISBURSAL_TO_LMS_API:"pls/v1/lead/application/disbursaldetail/disburse-to-lms/",
    USESR_VALIDATE_ESIGN_OTP_API:"pls/v1/lead-application/esign/validateOtp",
    USESR_VALIDATE_ESIGN_RESEND_OTP_API:"pls/v1/lead-application/esign/resend-otp/",
    USESR_INITIATE_PAYMENT_API:"lms/v1/loan/payment/init",
    USESR_INITIATE_PAYMENT_CALLBACK_API:"prs/v1/loan/payment/au/upi/callback",
    USESR_EMI_REPAYMENT_DATA_API:"lms/v1/loan/installments/find?loanAccountNumber=",
    USESR_ACCOUNT_STATEMENT_API:"reporting/report/accountStatement/report/generate/",
    USER_BANK_ANALYSER_API:"pls/v1/applicant/bankanalyser/init",
    USER_BANK_ANALYSER_GET_API:'pls/v1/applicant/bankanalyser/find/',
    GET_PROVEDIER_DETAILS:'prs/v1/loan/payment/provider',
    GET_BRANCHES_BY_LOCATION_API: '/v1/postcode/list',
    GET_BRANCHES_LIST_API:"core/v1/pincode-branch/mapping/find-mapped-branches?pincodes=",
    FIND_ALL_STATES:"core/master/state/findAll",
    USER_ADDRESS_UPDATE:"pls/v1/applicant-address/update/",
    CREATE_REQUEST_DIGIO:"/client/kyc/v2/request/with_template",
    GET_DIGIO_DOCUMENT_ID:"/client/kyc/v2/",
    GET_DIGIO_GET_MEDIA:"/client/kyc/v2/media/",
    FACE_LIVENESS_INIT:"core/v1/faceliveness/init",
    FACEE_LIVENESS_FETCH_DATA:"core/v1/faceliveness/fetch/",
    CHECK_THIRD_PARTY_INTEGRATION:"core/v1/thirdparty/integration/master/findAll",
    BANK_ANALYZER_INSITIUTE_NAMES:"pls/v1/applicant/bankanalyser/institutions?destination=STATEMENT_UPLOAD",
    GET_COLLATERAL_DETAILS:"lms/v1/customer/loan/collateral/",
    GET_CUSTOMER_LOAN_DETAILS:"lms/v1/customer/loan/detail/",
    FIND_LOAN_OUTSTANDING:"lms/v1/loan/findLoanOutstanding?loanAccountNumber=",
    MASTER_BLACK_LIST_PINCODE_FIND: "core/v1/blacklisted-pincode/findAll",
    MASTER_BLACK_LIST_PINCODE_FIND_BY_PINCODE: "core/v1/blacklisted-pincode/is-blacklisted?pincode=",
    GET_CUSTOMER_ELIGIBILITY:"pls/v1/applicant/cibil/eligibility/",
    GET_CUSTOMER_CIBIL:"pls/v1/applicant/cibil/find/",
    REJECT_LEAD_APPLICATION:"pls/v1/lead/update/status/",
    LOAN_MATURITY_DATE:"pls/v1/lead/repayment/calculate/maturity/",
    LEAD_SEARCH_API:"pls/v1/lead/search?status=",
    ACCOUNT_AGGREGRATOR_INITIATE:"pls/v1/applicant/account-aggregator/init",
    ACCOUNT_AGGREGRATOR_CHECK_STATUS:"core/v1/account-aggregator/checkStatus",
    ACCOUNT_AGGREGRATOR_REPORT:"core/v1/account-aggregator/retrieveReport",
    PARTNER_LEADS_API:"pls/v1/partner/leads/intake",
    CHECK_USER_LEAD_ELIGIBILITY:"pls/v1/lead/eligibility",
    UPDATE_AADHAR_DETAILS:"pls/v1/applicant-address/update/",
    IVR_INITIATE:"notification/v1/ivr/notification/initiate-call",
    ASSIGN_LEAD_TO_USER:"pls/v1/lead-assignment/assign",
    UNASSIGNED_LEAD_TO_USER:"pls/v1/lead-assignment/unassign",
    GET_ALL_USER_DETAILS:"core/v1/admin/user/findAll",
    GET_BANK_ANALYZER:"pls/v1/applicant/bankanalyser/find/"
};
